import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';
import { useAuth } from '../context/AuthContext';

export default function SettingsPage() {
  const { auth } = useAuth();

  return (
    <Box>
      <Typography variant="h5" gutterBottom fontWeight={600}>
        Asetukset
      </Typography>

      <Card sx={{ mb: 2 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Tunnistautuminen
          </Typography>
          <Typography variant="body2">
            Kirjautunut: <strong>{auth?.email || 'Tuntematon'}</strong>
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            Sallitut sähköpostit määritetään palvelimen ALLOWED_EMAILS-ympäristömuuttujalla.
            Niitä ei voi muuttaa käyttöliittymästä.
          </Typography>
        </CardContent>
      </Card>

      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Tietoja
          </Typography>
          <Typography variant="body2">
            HomeLedger v1.0.0 — Henkilökohtainen taloussovellus
          </Typography>
          <Typography variant="body2" color="text.secondary">
            React + Azure Static Web Apps + Azure Functions
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}
